var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrightcloudysky(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 120,
    viewBox: "0 0 200 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.1 55H133.7C131.4 50 125.1 44.5 117.6 44.5C114 44.5 110.7 45.7 108 47.5C104.5 40.1 96.6002 35 87.5002 35C75.3002 35 65.3002 44.2 65.3002 55.6C57.2002 56.1 50.7002 62.6 50.7002 70.2C50.7002 78.2 57.7002 84.9 66.3002 84.9H135.2C143.8 84.9 150.8 77.9 150.8 69.9C150.6 62 143.6 55 135.1 55Z",
    fill: "#99CCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightcloudysky);
export default __webpack_public_path__ + "static/media/Bright cloudy sky.306d173e61c796e481108d82ab95cc5a.svg";
export { ForwardRef as ReactComponent };